import { Component, inject } from '@angular/core';
import { LandingComponent } from './pages/landing/landing.component';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    imports: [RouterModule],
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
})
export class AppComponent {
    title = 'LamainApp';
    translate = inject(TranslateService);
    langService = inject(LanguageService);
    constructor() {
        // this.translate.addLangs(['fr', 'en']);
        // this.translate.setFallbackLang('en');
        // this.translate.use('en');
        // const browserLang = this.translate.getBrowserLang();
        // this.translate.use(browserLang?.match(/en|fr/) ? browserLang : 'en');
    }
}
